import { render, staticRenderFns } from "./FormTextBox.vue?vue&type=template&id=0fb94886&"
import script from "./FormTextBox.vue?vue&type=script&lang=js&"
export * from "./FormTextBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports